<!-- Logo/Header -->
<div class="sidenav-header" *ngIf="config.logo">
  <div class="logo-container">
    <div class="logo-icon">
      <mat-icon class="shield-icon">{{ config.logo.icon }}</mat-icon>
    </div>
    <span *ngIf="config.logo.title" class="logo-title">{{ config.logo.title }}</span>
  </div>
</div>

<!-- Navigation Items -->
<mat-nav-list class="nav-list">
  <ng-container *ngFor="let item of config.navItems; let i = index">
    <mat-list-item 
      [routerLink]="item.disabled ? null : item.route"
      [class.active]="item.active"
      [class.disabled]="item.disabled"
      (click)="!item.disabled && onNavItemClick(item)"
      class="nav-item">
      
      <mat-icon matListItemIcon class="nav-icon">{{ item.icon }}</mat-icon>
      <span matListItemTitle class="nav-label">{{ item.label }}</span>
    </mat-list-item>
    
    <!-- Divider between FID Picker and Data Readiness (after first item) -->
    <mat-divider class="nav-divider" *ngIf="i === 0 && config.navItems.length > 1"></mat-divider>
    
    <!-- Divider before User Management (after Data Viewer, which is second-to-last item) -->
    <mat-divider class="nav-divider" *ngIf="i === config.navItems.length - 2 && config.navItems.length > 2"></mat-divider>
  </ng-container>
</mat-nav-list> 